import { buttonVariants } from "@/components/ui/button";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarSeparator,
} from "@/components/ui/sidebar";
import { Link } from "@tanstack/react-router";
import { History, ScrollText } from "lucide-react";
import { SidebarHistory } from "./sidebar-history";
import CreditCounter from "./credit-counter";
import { AddCredits } from "./pricing-dialog";

export function AppSidebar() {
  return (
    <Sidebar variant="floating" id="history-sidebar">
      <SidebarHeader>
        <Link to="/" className="relative w-20 h-16">
          <img src={"/logo.png"} alt="logo" className="object-contain" />
        </Link>
      </SidebarHeader>
      <SidebarSeparator className="invisible" />
      <SidebarHeader className="w-full">
        <Link
          className={buttonVariants({
            className: "gap-2",
          })}
          to={"/dashboard"}
        >
          <ScrollText className="size-4" />
          Convert Transcript
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="flex items-center gap-2">
            <History className="size-10" />
            Conversion History
          </SidebarGroupLabel>
          <SidebarSeparator className="my-2" />
          <SidebarHistory />
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <AddCredits />
        <CreditCounter />
      </SidebarFooter>
    </Sidebar>
  );
}
